<div class="filters-panel-container">
    <aside class="filters-panel p-3">
        <span [hidden]="!(tags?.length > 0)">
            <div class="combination" [hidden]="selected_tags.length === 0">
                <div class="tags-selected">
                    @for(tag of selected_tags; track tag) {
                        <p>
                            {{tag.name}}
                            <span class="tag-operator" [hidden]="!isThereATagFollowing($index, selected_tags.length)">
                                @switch(selectedCombinator) {
                                    @case('any'){
                                        {{ 'or_operator' | translate }} 
                                    }
                                    @case('all'){
                                        &
                                    }
                                }
                            </span>
                        </p>
                    }
                </div>
            </div>

            <div class="tags">
                <p>
                    <a href="https://help.teammood.com/teammood-structure/tags-categorization-and-anonymity" title="Learn more about tags" target="_blank">
                        {{'learn_more' | translate}}</a> {{'tag.explain' | translate}}.
                </p>
                <select class="form-select mt-2" [(ngModel)]="selectedCombinator" (change)="changedCombinator()">
                    <option value="any" [disabled]="!anySelectorIsActive()">{{'combination_text' | translate}}
                        {{'any_choice' | translate}}
                    </option>
                    <option value="all" [disabled]="!allSelectorIsActive()">{{'combination_text' | translate}}
                        {{'all_choice' | translate}}
                    </option>
                </select>

                @for(tag of tags; track tag) {
                    <div class="checkboxes-filters-container">

                        <div class="checkboxes-filters d-flex align-items-center my-2">
                            <input type="checkbox" id="{{ tag.name | remove_non_alphanumeric }}" 
                                   (click)="updateTags(tag)" [disabled]="!tagIsActive(tag)" [checked]="tag.isSelected">
                            @if(tagIsActive(tag)) {
                                <label class="m-0 p-0" for="{{ tag.name | remove_non_alphanumeric }}">{{tag.name}}</label>
                            }@else{
                                <label class="m-0 p-0 filter-disabled w-auto" for="{{ tag.name }}"
                                       matTooltip="{{ 'tag.disabled'| translate}}"
                                       matTooltipPosition="above">
                                    {{tag.name}} <i class="far fa-question-circle"></i>
                                </label>
                            }
                        </div>
    
                    </div>
                }
            </div>
        </span>

    </aside>
</div>